import React from 'react'

export default function BackIcon() {
  return (
    <div style={{transform: 'scale(2)'}}>
      <svg width="15" height="15" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="34" height="34" rx="2" fill="#DDDDDD" />
        <rect x="29.3271" y="18.218" width="24" height="2" rx="1" transform="rotate(-180 29.3271 18.218)" fill="#AAAAAA" />
        <rect x="11.9272" y="24.218" width="9.69976" height="2" rx="1" transform="rotate(-135.575 11.9272 24.218)" fill="#AAAAAA" />
        <rect width="9.69976" height="2" rx="1" transform="matrix(-0.714162 0.699981 0.699981 0.714162 11.9272 10)" fill="#AAAAAA" />
      </svg>
    </div>
  )
}

BackIcon.displayName = 'BackIcon'